import { Club } from '../../../types/club';
import { Iteration } from '../../../types/competition';
import { PositionGroupClubIteration } from '../../../types/player';
import { RatingRequirement } from '../../../types/scouting';


export type SeasonScoutingFilter =
  | 'minutes'
  | 'maxAge'
  | 'positionsAndRoles'
  | 'iterations'
  | 'orderBy'
  | 'clubs'
  | 'ratings'
  | 'nationalities'
  | 'contractStatus';


export interface SeasonScoutingState {

  // filters applied to current search result
  currentMinutes: string[];
  currentMaxAge: string[];
  currentPositions: string[];
  currentRoles: string[];
  currentIterations: Iteration[];
  currentOrderBy: string[];
  currentOrderByToggle: boolean;

  currentClubs: Club[];
  currentRatings: RatingRequirement[];
  currentNationalities: string[];
  currentContractStatus: string[];
  currentIsContractStatusToggled: boolean;

  // filter expansion state
  currentFilterExpanded: SeasonScoutingFilter | undefined,
  previousFilterExpanded: SeasonScoutingFilter | undefined;

  // search state
  tableData: PositionGroupClubIteration[];
  playerIdsOnCurrentPage: number[];
  currentModuloPage: number; // currentModuloPage (page % pagesPerChapter) is 1-indexed
  currentChapter: number; // chapters are 0-indexed
  totalHits: number;
  isLoading: boolean;
  isEmptySearchResult: boolean;
  searchWasLoaded: boolean;

  // other state
  modalTypeOpen: 'saveSearch' | 'loadSearch' | undefined;
}


export const initialSeasonScoutingState: SeasonScoutingState = {

  // filters applied to current search result
  currentMinutes: [],
  currentMaxAge: [],
  currentPositions: [],
  currentRoles: [],
  currentIterations: [],
  currentOrderBy: [],
  currentOrderByToggle: false,

  currentClubs: [],
  currentRatings: [],
  currentNationalities: [],
  currentContractStatus: [],
  currentIsContractStatusToggled: false,

  // filter expansion state
  currentFilterExpanded: undefined,
  previousFilterExpanded: undefined,

  // search state
  tableData: [],
  playerIdsOnCurrentPage: [],
  currentModuloPage: 0,
  currentChapter: 0,
  totalHits: 0,
  isLoading: false,
  isEmptySearchResult: false,
  searchWasLoaded: false,

  // other state
  modalTypeOpen: undefined,
};
